module.exports = __webpack_public_path__ + "img/homepage_01.846870fb.jpg";